import { types } from "mobx-state-tree";
import fetcher from "../utils/fetcher";

const OrdersStore = types
  .model("OrdersStore", {
    orders: types.frozen(),
    error: types.frozen(),
  })
  .actions((self) => {
    const getOrders = async (data) => {
      self.setError("");
      console.log(data);
      const response = await fetcher().post(data).from.orders.get_cust_orders();
      if (response?.status === 200 && response?.data) {
        self.setOrders(response.data);
        return response.data;
      } else {
        self.setError(
          response?.status === 400 || response?.status === 500
            ? response?.data?.FORM?.InterfaceErrors?.text || "error:error_failed_get_cust_orders"
            : "error:error_failed_get_cust_orders"
        );
      }
    };

    const setProducts = async (products) => {
      let chartList = {};
      const flatRes = products;

      if (flatRes?.length > 0) {
        const mapList = flatRes.map((p) => {
          return p?.ORDERITEMS_SUBFORM?.map((line) => {
            return {
              KLINE: p.ORD,
              project: p.DOCNO,
              TYPE: "C",
              LINE: line.ORDI,
              ORDI: line.ORDI,
              ORD: p.ORD,
              id: line.ZACP_FAMEXMPARTNAME,
              description: line.PDES,
              openingType: line.ZACP_OPNTYPWEB,
              length: line.AMA_SPEC16,
              width: line.AMA_SPEC17,
              quantity: line.TQUANT,
              color: line.ZACP_SPEC19,
              productionInstraction: line.ZACP_REMARK,
              buildingNo: line.ZACP_BUILDING,
              floorNo: line.ZACP_FLOOR,
              apartmentNo: line.ZACP_APARTMENT,
              balance: line.ZACP_PROJTBALANCE,
            };
          });
        });
        const mapListFlat = mapList.flat(1);

        chartList = mapListFlat?.reduce((acc, currentValue) => {
          let groupKey = currentValue["id"];

          if (!acc[groupKey]) {
            acc[groupKey] = [];
          }
          acc[groupKey].push(currentValue);
          return acc;
        }, {});
      }

      return chartList;
    };

    const setOrdersReport = async (data) => {
      self.setError("");
      const report = await fetcher().post(data).from.orders.set_orders_report();
      if (report?.status === 200 && report?.data) {
        return report.data;
      } else {
        console.log("error:error_failed_set_orders_report_req");
        self.setError("error:error_failed_set_orders_report_req");
      }
    };

    const getReport = async (data) => {
      self.setError("");
      const report = await fetcher().post(data).from.orders.get_report();
      if (report?.status === 200 && report?.data) {
        return report.data;
      } else {
        console.log("error:error_failed_get_report_req");
        self.setError("error:error_failed_get_report_req");
      }
    };

    const getProjectOrder = async (data) => {
      self.setError("");
      const order = await fetcher().post(data).from.orders.get_project_order();
      if (order?.status === 200 && order?.data) {
        return order.data?.value?.length ? order.data?.value[0] : undefined;
      } else {
        console.log("error:error_failed_get_project_order_req");
        self.setError("error:error_failed_get_project_order_req");
      }
    };

    const getProjectProducts = async (data) => {
      self.setError("");
      const orders = await fetcher().post(data).from.orders.get_project_order_products();
      if (orders?.status === 200 && orders?.data) {
        const products = setProducts(orders?.data);
        return products;
      } else {
        console.log("error:error_failed_get_project_order_productsr_req");
        self.setError("error:error_failed_get_project_order_products_req");
      }
    };

    const setError = (error) => {
      self.error = error;
    };

    const setOrders = (orders) => {
      self.orders = orders;
    };

    return {
      setError,
      getOrders,
      setOrders,
      getReport,
      setOrdersReport,
      getProjectOrder,
      getProjectProducts,
    };
  })
  .views((self) => ({
    get isError() {
      return !!self.error;
    },
  }));

const ordersStore = OrdersStore.create({
  error: "",
  orders: [],
});

export default ordersStore;
